import Script from 'next/script';
import PropTypes from 'prop-types';
import { TRUSTED_BADGE_VARIANT } from '@/constants/trustedBadgeRating';
import { URLS } from '@/constants/urls';
import { useAppSelector } from '@/redux';
import styles from './TrustedBadge.module.scss';

const TrustedBadge = ({ variant = TRUSTED_BADGE_VARIANT.LIGHT }) => {
	const widgetId = useAppSelector(({ root }) => root.storeConf?.trustedShopsWidget?.[variant]);

	if (!widgetId) {
		return null;
	}

	return (
		<div className={styles.container} data-test-id="trusted-badge">
			<Script id="etrusted-widget-script" src={URLS.TRUSTEDSHOP_WIDGET} strategy="lazyOnload" />
			<etrusted-widget data-etrusted-widget-id={widgetId} />
		</div>
	);
};

TrustedBadge.propTypes = {
	variant: PropTypes.oneOf(Object.values(TRUSTED_BADGE_VARIANT)),
};

export default TrustedBadge;
